let StudyPlannerYourProfile = Backbone.Model.extend({
    defaults: {
        planner: null,
        dailyRoutine: null,
        family: null,
        work: null,
        commuting: null,
        lifestyle: null,
        schedule: null,
    },

    initialize: function () {
        this.set('planner', new PlannerYourProfile(this.get('planner')));
        this.set('dailyRoutine', new YourDailyRoutine(this.get('dailyRoutine')));
        this.set('family', new YourFamily(this.get('family')));
        this.set('work', new YourWork(this.get('work')));
        this.set('commuting', new YourCommuting(this.get('commuting')));
        this.set('lifestyle', new YourLifestyle(this.get('lifestyle')));
        this.set('schedule', new Schedule(this.get('schedule')));
    },

    getPlannerProfile: function () {
        return this.get('planner');
    },

    getDailyRoutine: function () {
        return this.get('dailyRoutine');
    },

    getFamily: function() {
        return this.get('family');
    },

    getWork: function() {
        return this.get('work');
    },

    getCommuting: function() {
        return this.get('commuting');
    },

    getLifestyle: function() {
        return this.get('lifestyle');
    },

    getSchedule: function() {
        return this.get('schedule');
    },

    setSchedule: function(schedule) {
        this.set('schedule', schedule);
    },

    clearSchedule: function() {
        this.setSchedule(null);
    },

    averageUtilisedHours: function() {
        let section = plannerApplication.yourProfile.getCurrentSection();
        return (section >= StudyPlannerSections.family ? this.getFamily().averageUtilisedHours() : 0) +
               (section >= StudyPlannerSections.work ? this.getWork().averageUtilisedHours() : 0) +
               (section >= StudyPlannerSections.commuting ? this.getCommuting().averageUtilisedHours() : 0) +
               (section >= StudyPlannerSections.lifestyle ? this.getLifestyle().averageUtilisedHours() : 0);
    },
});
